@file:OptIn(InternalResourceApi::class)

package mobile_wallet.libs.mifos_passcode.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.libs.mifos_passcode.generated.resources/"

internal val Res.string.lib_mifos_passcode: StringResource by lazy {
      StringResource("string:lib_mifos_passcode", "lib_mifos_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 403, 38),
      ))
    }

internal val Res.string.lib_mifos_passcode_cancel: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_cancel", "lib_mifos_passcode_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 41),
      ))
    }

internal val Res.string.lib_mifos_passcode_drag_passcode: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_drag_passcode", "lib_mifos_passcode_drag_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52, 60),
      ))
    }

internal val Res.string.lib_mifos_passcode_has_drag_passcode: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_has_drag_passcode", "lib_mifos_passcode_has_drag_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113, 64),
      ))
    }

internal val Res.string.lib_mifos_passcode_has_passcode: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_has_passcode", "lib_mifos_passcode_has_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178, 55),
      ))
    }

internal val Res.string.lib_mifos_passcode_pref_name: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_pref_name", "lib_mifos_passcode_pref_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234, 48),
      ))
    }

internal val Res.string.lib_mifos_passcode_title: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_title", "lib_mifos_passcode_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283, 84),
      ))
    }

internal val Res.string.lib_mifos_passcode_yes: StringResource by lazy {
      StringResource("string:lib_mifos_passcode_yes", "lib_mifos_passcode_yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 368, 34),
      ))
    }

internal val Res.string.library_mifos_passcode_confirm_passcode: StringResource by lazy {
      StringResource("string:library_mifos_passcode_confirm_passcode", "library_mifos_passcode_confirm_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 442, 71),
      ))
    }

internal val Res.string.library_mifos_passcode_create_passcode: StringResource by lazy {
      StringResource("string:library_mifos_passcode_create_passcode", "library_mifos_passcode_create_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 514, 66),
      ))
    }

internal val Res.string.library_mifos_passcode_delete_passcode: StringResource by lazy {
      StringResource("string:library_mifos_passcode_delete_passcode", "library_mifos_passcode_delete_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 581, 82),
      ))
    }

internal val Res.string.library_mifos_passcode_do_not_match: StringResource by lazy {
      StringResource("string:library_mifos_passcode_do_not_match", "library_mifos_passcode_do_not_match", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 664, 75),
      ))
    }

internal val Res.string.library_mifos_passcode_drag_guide: StringResource by lazy {
      StringResource("string:library_mifos_passcode_drag_guide", "library_mifos_passcode_drag_guide", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 740, 101),
      ))
    }

internal val Res.string.library_mifos_passcode_drag_your_pattern: StringResource by lazy {
      StringResource("string:library_mifos_passcode_drag_your_pattern", "library_mifos_passcode_drag_your_pattern", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 842, 72),
      ))
    }

internal val Res.string.library_mifos_passcode_enter_your_passcode: StringResource by lazy {
      StringResource("string:library_mifos_passcode_enter_your_passcode", "library_mifos_passcode_enter_your_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 915, 78),
      ))
    }

internal val Res.string.library_mifos_passcode_exit: StringResource by lazy {
      StringResource("string:library_mifos_passcode_exit", "library_mifos_passcode_exit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1078, 43),
      ))
    }

internal val Res.string.library_mifos_passcode_exit_message: StringResource by lazy {
      StringResource("string:library_mifos_passcode_exit_message", "library_mifos_passcode_exit_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 994, 83),
      ))
    }

internal val Res.string.library_mifos_passcode_forgot_passcode: StringResource by lazy {
      StringResource("string:library_mifos_passcode_forgot_passcode", "library_mifos_passcode_forgot_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1122, 66),
      ))
    }

internal val Res.string.library_mifos_passcode_login_manually: StringResource by lazy {
      StringResource("string:library_mifos_passcode_login_manually", "library_mifos_passcode_login_manually", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1189, 89),
      ))
    }

internal val Res.string.library_mifos_passcode_skip: StringResource by lazy {
      StringResource("string:library_mifos_passcode_skip", "library_mifos_passcode_skip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1279, 43),
      ))
    }

internal val Res.string.library_mifos_passcode_try_again: StringResource by lazy {
      StringResource("string:library_mifos_passcode_try_again", "library_mifos_passcode_try_again", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1323, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("lib_mifos_passcode", Res.string.lib_mifos_passcode)
  map.put("lib_mifos_passcode_cancel", Res.string.lib_mifos_passcode_cancel)
  map.put("lib_mifos_passcode_drag_passcode", Res.string.lib_mifos_passcode_drag_passcode)
  map.put("lib_mifos_passcode_has_drag_passcode", Res.string.lib_mifos_passcode_has_drag_passcode)
  map.put("lib_mifos_passcode_has_passcode", Res.string.lib_mifos_passcode_has_passcode)
  map.put("lib_mifos_passcode_pref_name", Res.string.lib_mifos_passcode_pref_name)
  map.put("lib_mifos_passcode_title", Res.string.lib_mifos_passcode_title)
  map.put("lib_mifos_passcode_yes", Res.string.lib_mifos_passcode_yes)
  map.put("library_mifos_passcode_confirm_passcode", Res.string.library_mifos_passcode_confirm_passcode)
  map.put("library_mifos_passcode_create_passcode", Res.string.library_mifos_passcode_create_passcode)
  map.put("library_mifos_passcode_delete_passcode", Res.string.library_mifos_passcode_delete_passcode)
  map.put("library_mifos_passcode_do_not_match", Res.string.library_mifos_passcode_do_not_match)
  map.put("library_mifos_passcode_drag_guide", Res.string.library_mifos_passcode_drag_guide)
  map.put("library_mifos_passcode_drag_your_pattern", Res.string.library_mifos_passcode_drag_your_pattern)
  map.put("library_mifos_passcode_enter_your_passcode", Res.string.library_mifos_passcode_enter_your_passcode)
  map.put("library_mifos_passcode_exit", Res.string.library_mifos_passcode_exit)
  map.put("library_mifos_passcode_exit_message", Res.string.library_mifos_passcode_exit_message)
  map.put("library_mifos_passcode_forgot_passcode", Res.string.library_mifos_passcode_forgot_passcode)
  map.put("library_mifos_passcode_login_manually", Res.string.library_mifos_passcode_login_manually)
  map.put("library_mifos_passcode_skip", Res.string.library_mifos_passcode_skip)
  map.put("library_mifos_passcode_try_again", Res.string.library_mifos_passcode_try_again)
}
